module.exports = __webpack_public_path__ + "img/remote-lab-logo.1b1e0c9c.png";